// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"364":"AddUser","534":"AddFoodItem"}[chunkId] || chunkId) + "." + {"62":"6ebc044a","184":"4db0c2bb","364":"11809ce1","405":"4416fae2","534":"75358e60","577":"181649f1","715":"5ed7ac4a","787":"802e209f"}[chunkId] + ".chunk.js";
};